import React from 'react';
import imgevent from '../../images/event.jpg';
import {useTranslation } from "react-i18next";   

function Events() {
    const { t, i18n } = useTranslation();
    return (
    <section id="events" className="events">
        <div className="container" >
            <div className="section-title">
                <h2>{t("events")}</h2>
                <p>{t("event-title")} <span className="text-old">Old Tbilisi</span></p>
            </div>
            <div className="row event-item px-2 d-flex">  
                <div className="col-md-6 pt-4 pt-lg-0 pb-3 content">
                    <div className="price">
                        <p><span>{t("event-h")}</span></p>
                    </div>
                    <p className="font-italic">
                    {t("event-p-1")}
                    </p>
                    <ul>
                        <li><i className="fas fa-check"></i> {t("event-li-1")}</li>
                        <li><i className="fas fa-check"></i> {t("event-li-2")}</li>
                        <li><i className="fas fa-check"></i> {t("event-li-3")}</li>
                    </ul>
                    <div className="info">
                        <div className="address">
                            <a href="#gallery"><i className="far fa-images"></i>
                            </a>
                            <h4>{t("gallery")}</h4>
                            <p className="pb-3">{t("event-gallery-p")}</p>
                        </div>
              
                        <div className="address px-2">
                            <a href="https://www.instagram.com/old_tbilisii/" target="_blank" rel="noreferrer">
                                <i className="me-2 fab fa-instagram"></i>
                            </a>
                            <a href="https://www.facebook.com/oldtbilisi2021/" target="_blank" rel="noreferrer">
                                <i className="me-2 fab fa-facebook-f"></i>
                            </a>                            
                            <i className="fas fa-map-marker-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter3"></i>
                        </div>
                    </div>
                </div>
                <div className="center col-md-6">
                    <img className="img-fluid max-h" src={imgevent} alt="Event at Old Tbilisi, for more information follow us on social media"/>
                </div>
                    
        
            </div>   
        </div>
    </section>
    )
}

export default Events;
